import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Row, Col, Button, Checkbox, Select, Image, Modal } from "antd";
import { InputCustom } from "../componentes/inputComponent";
import { SelectCustom } from "../componentes/selectComponent";
import { InputCustomNumber } from "../componentes/inputComponentNumber";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { manejarError } from "../manejo_errores";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import moment from "moment";
import { HeadersAuth } from "../funciones_utiles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { IdcardOutlined, PlusOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { ModalNotificacion } from "../componentes/modalNotificacion";
import { FilePdfOutlined } from "@ant-design/icons";

export const AltaPilotos = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  //Estados del Componente
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({}); //Almacena temporalmente los datos del formulario
  const [fetchDatos, setFetchDatos] = useState([]); //Guarda los datos de los pilotos obtenidos del backend
  const [refresh, setRefresh] = useState(""); //Se utiliza para forzar la actualización de la lista de pilotos
  const [idUnico, setIdUnico] = useState(); //ID del piloto seleccionado para edición
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [passwordActual, setPasswordActual] = useState("");
  const [passwordNueva, setPasswordNueva] = useState("");
  const [passwordNuevaRepetir, setPasswordNuevaRepetir] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [mostrarFormularioPiloto, setMostrarFormularioPiloto] = useState(false); // Estado del primer formulario
  const [mostrarFormularioPassword, setMostrarFormularioPassword] = useState(false); // Estado del segundo formulario
  const [invitado, setInvitado] = useState(false);
  const [abrirModalNotificacion, setAbrirModalNotificacion] = useState(false);
  const [eliminarId, setEliminarId] = useState(null);
  const [dataNotificacion, setDataNotificacion] = useState([]);
  const [modoLicencia, setModoLicencia] = useState("");
  const [campeonatoLicencia, setCampeonatoLicencia] = useState("");
  const [licenciaActual, setLicenciaActual] = useState(null);

  const [licenciaFrente, setLicenciaFrente] = useState("");
  const [licenciaDorso, setLicenciaDorso] = useState("");

  const [previewLicenciaFrente, setPreviewLicenciaFrente] = useState("");
  const [previewLicenciaDorso, setPreviewLicenciaDorso] = useState("");

  const [campeonatosLicencia, setCampeonatosLicencia] = useState([]);

  const [modalLicenciaVisible, setModalLicenciaVisible] = useState(false);
  const [previewLicenciaPdf, setPreviewLicenciaPdf] = useState("");
  const [licenciaPdf, setLicenciaPdf] = useState("");
  const [campeonatoActual, setCampeonatoActual] = useState(null);


  // useState(true);
  //Carga de datos iniciales
  //Carga los datos de un piloto específico cuando idUnico cambia

  useEffect(() => {
    if (sesion?.id_asociacion) {
      fetchCampeonatosLicencia(sesion.id_asociacion);
    }
  }, [sesion?.id_asociacion]);

  useEffect(() => {
    if (idUnico) {
      (async () => {
        const URI_PILOTO = process.env.REACT_APP_DOMINIO + "/piloto/" + idUnico;

        const datosPiloto = await traerDatosObjeto(URI_PILOTO);

        if (datosPiloto) {
          const fechaNacimientoFormateada = moment(
            datosPiloto.fecha_nacimiento
          ).format("YYYY-MM-DD");
          // Actualiza el estado con los datos del piloto
          setTempDatosFormulario({
            ...datosPiloto,
            fecha_nacimiento: fechaNacimientoFormateada,
            imagen: ""
          });
          setMostrarBotonLimpiar(true);
        } else {

          manejarAlertas("error", "No se recibieron datos del piloto.");
        }
      })();
    } else {
      // Estado inicial cuando no hay ID seleccionado
      setTempDatosFormulario({
        dni: "",
        nombre: "",
        apellido: "",
        numero_telefono: "",
        fecha_nacimiento: "",
        password: "",
        email: "",
        imagen: "",
        direccion: "",
        localidad: "",
        obra_social: "",
        seguro: "",
        esInvitado: false
      });
      setMostrarBotonLimpiar(false);
    }
  }, [idUnico]);

  const guardarLicenciaWebConPilotoId = async (pilotoId) => {
    try {
      if (!campeonatoLicencia) return;

      const vieneConPdf = modoLicencia === "pdf" && !!licenciaPdf;
      const vieneConImagenes =
        modoLicencia === "imagenes" && licenciaFrente && licenciaDorso;

      if (!vieneConPdf && !vieneConImagenes) return;

      const body = {
        id_piloto: pilotoId,
        id_asociacion: sesion.id_asociacion,
        id_campeonato: campeonatoLicencia,
        tipo_archivo: modoLicencia === "pdf" ? "PDF" : "IMAGEN",
      };

      if (vieneConPdf) {
        body.licencia_pdf = licenciaPdf;
      }

      if (vieneConImagenes) {
        body.foto_frente = licenciaFrente;
        body.foto_dorso = licenciaDorso;
      }

      await axios.post(
        `${process.env.REACT_APP_DOMINIO}/licencias-deportivas/guardar`,
        body,
        HeadersAuth
      );

      await fetchPilotos(sesion.id_asociacion, invitado);
    } catch (error) {
      manejarAlertas(
        "error",
        "El piloto se guardó pero ocurrió un error al guardar la licencia médica."
      );
    }
  };

  //Guardar piloto
  //Guarda o actualiza un piloto dependiendo de si idUnico está definido
  const guardarPiloto = async () => {
    try {
      let url = idUnico
        ? `${process.env.REACT_APP_DOMINIO}/piloto/${idUnico}`
        : `${process.env.REACT_APP_DOMINIO}/piloto`;

      let response;

      if (idUnico) {
        response = await axios.put(
          url,
          tempDatosFormulario,
          HeadersAuth
        );
      } else {
        response = await axios.post(
          url,
          tempDatosFormulario,
          HeadersAuth
        );
      }

      if (response.status === 200) {

        // =========================
        // LICENCIA DEPORTIVA
        // =========================

        // CREACIÓN
        if (!idUnico) {
          const pilotoCreadoId = response.data?.piloto?.id;

          if (
            pilotoCreadoId &&
            campeonatoLicencia &&
            (
              (modoLicencia === "imagenes" && licenciaFrente && licenciaDorso) ||
              (modoLicencia === "pdf" && licenciaPdf)
            )
          ) {
            await guardarLicenciaWebConPilotoId(pilotoCreadoId);
          }
        }

        // EDICIÓN
        if (idUnico) {
          if (
            campeonatoLicencia &&
            (
              (modoLicencia === "imagenes" && (licenciaFrente || licenciaDorso)) ||
              (modoLicencia === "pdf" && licenciaPdf)
            )
          ) {
            await guardarLicenciaWeb();
          }
        }

        manejarAlertas("success", "Guardado exitoso");

        // =========================
        // LIMPIAR FORMULARIO
        // =========================

        setTempDatosFormulario({
          dni: "",
          nombre: "",
          apellido: "",
          numero_telefono: "",
          fecha_nacimiento: "",
          password: "",
          email: "",
          imagen: "",
          direccion: "",
          localidad: "",
          obra_social: "",
          seguro: "",
          esInvitado: "",
        });

        // Imagen piloto
        setPreviewImage("");

        // Licencia deportiva
        setModalLicenciaVisible(false);
        setCampeonatoLicencia(null);
        setLicenciaActual(null);

        setLicenciaFrente("");
        setLicenciaDorso("");

        setPreviewLicenciaFrente("");
        setPreviewLicenciaDorso("");

        // Ocultar
        setMostrarFormularioPiloto(false);
        setMostrarBotonLimpiar(false);

        // Reset
        setIdUnico(null);

        // Refresh
        setRefresh(Date.now());

        // Notificaciones
        if (response.data.requiereNotificacion) {
          setAbrirModalNotificacion(true);
          setDataNotificacion(
            response.data.notificacionSistema
          );
        }
      }
    } catch (error) {
      manejarAlertas(
        "error",
        manejarError(error)
      );
    }
  };

  const fetchCampeonatosLicencia = async (id_asociacion) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO +
          `/campeonato/asociacion/${id_asociacion}`,
        HeadersAuth
      );

      if (response.status === 200) {
        const campeonatos = Array.isArray(response.data)
          ? response.data
          : [response.data];

        setCampeonatosLicencia(campeonatos);

        if (!campeonatoLicencia && campeonatos.length > 0) {
          setCampeonatoLicencia(campeonatos[0].id);
        }

        const anioActual = new Date().getFullYear();

        const campeonatoActualEncontrado = campeonatos.find(
          (camp) =>
            camp.activo !== false &&
            Number(camp.año || camp.anio) === anioActual
        );

        setCampeonatoActual(campeonatoActualEncontrado || null);

        if (campeonatoActualEncontrado) {
          setCampeonatoLicencia(campeonatoActualEncontrado.id);
        }

      } else {
        manejarAlertas("error", "No se encontraron Campeonatos.");
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const obtenerLicenciaWeb = async (idPiloto, idCampeonato) => {
    try {
      if (!idPiloto || !idCampeonato) return;

      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/licencias-deportivas/${idPiloto}/${sesion.id_asociacion}/${idCampeonato}`,
        HeadersAuth
      );

      const licencia = response.data.licencia || null;
      setLicenciaActual(licencia);

      setLicenciaFrente("");
      setLicenciaDorso("");
      setLicenciaPdf("");
      setPreviewLicenciaFrente("");
      setPreviewLicenciaDorso("");
      setPreviewLicenciaPdf("");

      if (!licencia) {
        setModoLicencia("");
        return;
      }

      if (licencia.licencia_pdf || licencia.tipo_archivo === "PDF") {
        setModoLicencia("pdf");

        setPreviewLicenciaPdf(
          getUrlLicenciaPiloto(licencia, licencia.licencia_pdf)
        );

        return;
      }

      setModoLicencia("imagenes");

      setPreviewLicenciaFrente(
        `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${idCampeonato}/piloto_${idPiloto}/${licencia.foto_frente}`
      );

      setPreviewLicenciaDorso(
        `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${idCampeonato}/piloto_${idPiloto}/${licencia.foto_dorso}`
      );
    } catch (error) {
      setLicenciaActual(null);
      setModoLicencia("");
      setLicenciaFrente("");
      setLicenciaDorso("");
      setLicenciaPdf("");
      setPreviewLicenciaFrente("");
      setPreviewLicenciaDorso("");
      setPreviewLicenciaPdf("");
    }
  };

  const limpiarImagenesLicencia = () => {
    setLicenciaFrente("");
    setLicenciaDorso("");
    setPreviewLicenciaFrente("");
    setPreviewLicenciaDorso("");
  };

  const limpiarPdfLicencia = () => {
    setLicenciaPdf("");
    setPreviewLicenciaPdf("");
  };

  const handleLicenciaImageChange = (e, lado) => {
    const file = e.target.files && e.target.files[0];

    if (!file) {
      manejarAlertas("error", "No se seleccionó ningún archivo válido");
      return;
    }

    if (!file.type.startsWith("image/")) {
      manejarAlertas("error", "Solo se permiten imágenes JPG, JPEG o PNG.");
      return;
    }

    limpiarPdfLicencia();
    setModoLicencia("imagenes");

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;

      if (lado === "frente") {
        setLicenciaFrente(base64String);
        setPreviewLicenciaFrente(base64String);
      }

      if (lado === "dorso") {
        setLicenciaDorso(base64String);
        setPreviewLicenciaDorso(base64String);
      }
    };

    reader.readAsDataURL(file);
  };

  const handleLicenciaPdfChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    if (file.type !== "application/pdf") {
      manejarAlertas("error", "El archivo debe ser PDF.");
      return;
    }

    limpiarImagenesLicencia();
    setModoLicencia("pdf");

    const reader = new FileReader();

    reader.onloadend = () => {
      setLicenciaPdf(reader.result);
      setPreviewLicenciaPdf(URL.createObjectURL(file));
    };

    reader.readAsDataURL(file);
  };

  const guardarLicenciaWeb = async () => {
    try {
      if (!idUnico) {
        manejarAlertas("error", "Primero debés seleccionar o guardar un piloto.");
        return;
      }

      if (!campeonatoLicencia) {
        manejarAlertas("error", "Seleccioná un campeonato.");
        return;
      }

      const vieneConPdf = modoLicencia === "pdf" && !!licenciaPdf;
      const vieneConImagenes =
        modoLicencia === "imagenes" && (!!licenciaFrente || !!licenciaDorso);

      if (vieneConPdf && vieneConImagenes) {
        manejarAlertas(
          "error",
          "Cargá la licencia como PDF o como imágenes, no ambos."
        );
        return;
      }

      if (!licenciaActual) {
        if (!vieneConPdf && (!licenciaFrente || !licenciaDorso)) {
          manejarAlertas(
            "error",
            "Para cargar una licencia nueva debés subir frente y dorso o un PDF."
          );
          return;
        }
      }

      if (licenciaActual) {
        if (!vieneConPdf && !licenciaFrente && !licenciaDorso) {
          manejarAlertas(
            "error",
            "Seleccioná al menos una imagen o un PDF para modificar."
          );
          return;
        }
      }

      const body = {
        id_piloto: idUnico,
        id_asociacion: sesion.id_asociacion,
        id_campeonato: campeonatoLicencia,
      };

      if (vieneConPdf) {
        body.licencia_pdf = licenciaPdf;
      } else {
        if (licenciaFrente) body.foto_frente = licenciaFrente;
        if (licenciaDorso) body.foto_dorso = licenciaDorso;
      }

      if (modoLicencia === "pdf") {
        if (licenciaPdf) {
          body.licencia_pdf = licenciaPdf;
        }

        body.tipo_archivo = "PDF";
      }

      if (modoLicencia === "imagenes") {
        if (licenciaFrente) body.foto_frente = licenciaFrente;
        if (licenciaDorso) body.foto_dorso = licenciaDorso;

        body.tipo_archivo = "IMAGEN";
      }

      const url = licenciaActual
        ? `${process.env.REACT_APP_DOMINIO}/licencias-deportivas/editar`
        : `${process.env.REACT_APP_DOMINIO}/licencias-deportivas/guardar`;

      const method = licenciaActual ? "put" : "post";

      const response = await axios[method](url, body, HeadersAuth);

      manejarAlertas(
        "success",
        response.data.message || "Licencia guardada correctamente."
      );

      await obtenerLicenciaWeb(idUnico, campeonatoLicencia);
      await fetchPilotos(sesion.id_asociacion, invitado);
      setLicenciaFrente("");
      setLicenciaDorso("");
      setLicenciaPdf("");

      setPreviewLicenciaFrente("");
      setPreviewLicenciaDorso("");
      setPreviewLicenciaPdf("");
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  //Obtiene la lista de pilotos asociados a una asociación específica
  useEffect(() => {
    const fetchData = async () => {
      await fetchPilotos(sesion.id_asociacion, invitado);
    };

    fetchData();
  }, [refresh]);

  const fetchPilotos = async (id_asociacion, invitadoValue = invitado) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/piloto-asociacion/${id_asociacion}`,
        {
          params: {
            ...(invitadoValue ? { esInvitado: "true" } : {}),
          },
        }
      );
      if (response.status === 200 && Array.isArray(response.data)) {
        setFetchDatos(response.data); // Asigna los datos a tu estado
      } else {
        manejarAlertas("error", "No se encontraron pilotos");

      }
    } catch (error) {
      // console.error("Error al obtener pilotos:", error);
      manejarAlertas("error", manejarError(error));

    }
  };

  const onChange = (e) => {
    const invitaciones = e.target.checked;
    // console.log("invitaciones", invitaciones)
    setInvitado(invitaciones);
    fetchPilotos(sesion.id_asociacion,invitaciones);
  };

  //Carga los datos de un piloto para edición
  const handleEdit = async (id) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (!id) {
      console.error("Error: idUnico es undefined");
      manejarAlertas("error", "Error al procesar la solicitud.");
      return;
    }
    try {
      const URI_PILOTO = process.env.REACT_APP_DOMINIO + "/piloto/" + id;
      const datosPiloto = await traerDatosObjeto(URI_PILOTO);
      // console.log("Datos del piloto obtenidos:", datosPiloto);

      // Actualizar los datos del formulario con los datos del piloto
      setTempDatosFormulario({
        dni: datosPiloto.dni,
        nombre: datosPiloto.nombre,
        apellido: datosPiloto.apellido,
        numero_telefono: datosPiloto.numero_telefono,
        fecha_nacimiento: datosPiloto.fecha_nacimiento,
        password: datosPiloto.password,
        email: datosPiloto.email,
        imagen: "",
        direccion: datosPiloto.direccion,
        localidad: datosPiloto.localidad,
        obra_social: datosPiloto.obra_social,
        seguro: datosPiloto.seguro,
        esInvitado: datosPiloto.esInvitado,
      } || {});

      // Manejar la lógica de la imagen
      if (datosPiloto.imagen) {
        setPreviewImage(
          `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/PILOTOS/${datosPiloto.imagen}`
        );
      } else {
        setPreviewImage(``);
      }

      // Establecer el ID único y mostrar los formularios
      setIdUnico(id);
      setMostrarFormularioPiloto(true);
      setMostrarFormularioPassword(true);

      setCampeonatoLicencia("");
      setLicenciaActual(null);
      setLicenciaFrente("");
      setLicenciaDorso("");
      setPreviewLicenciaFrente("");
      setPreviewLicenciaDorso("");
    } catch (error) {
      // console.error("Error al obtener los datos del piloto:", error);
      manejarAlertas("error", manejarError(error));
    }
  };

  const traerDatosObjeto = async (url) => {
    try {
      const response = await axios.get(url, HeadersAuth);
      if (response.status === 200) {
        return response.data;
      } else {
        console.error("Error al obtener datos:", response.statusText);
        manejarAlertas("error", "Error al obtener los datos.");
        return null;
      }
    } catch (error) {

      manejarAlertas("error", manejarError(error));
    }
  };
  // Elimina un piloto
  const handleEliminarPiloto = (id) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_DOMINIO}/piloto/pre-eliminar/${id}`,
            HeadersAuth
          );
          // Si requiere notificación → abrir modal ANTES de eliminar
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true);
            setDataNotificacion(response.data.notificacionSistema); 

            // Guardamos ID para eliminar luego
            setEliminarId(id);
            return;
          }

          // Si NO requiere notificación → eliminar directamente
          await eliminarPiloto(id);
        } catch (error) {
          manejarAlertas("error", manejarError(error));
        }
      }
    });
  };

  useEffect(() => {
    if (!abrirModalNotificacion && eliminarId) {
      eliminarPiloto(eliminarId);
      setEliminarId(null);
    }
  }, [abrirModalNotificacion]);

  const eliminarPiloto = async (id) => {
    try {
      // console.log("id que se envía", id)
      const response = await axios.delete(
        `${process.env.REACT_APP_DOMINIO}/piloto/${id}`,
        HeadersAuth
      );

      manejarAlertas("success", "El piloto ha sido eliminado.");
      setRefresh(Date.now());

    } catch (error) {
      console.error("Error al eliminar el piloto:", error);
      manejarAlertas("error", manejarError(error));
    }
  };

  //Manejo de Cambios en el Formulario
  const handleChange = (e) => {
    const { id, value } = e.target;
    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      // Validar que el archivo sea una imagen
      if (!file.type.startsWith("image/")) {
        console.warn("El archivo seleccionado no es una imagen válida.");

        manejarAlertas("error", "Solo se permiten archivos de imagen (JPG, JPEG, PNG).");
        return;
      }

      // Convertir el archivo a Base64
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result; // Resultado en Base64

        // Actualiza el estado del formulario con el Base64
        setTempDatosFormulario((prev) => ({
          ...prev,
          imagen: base64String, // Guarda la imagen en Base64
        }));

        // Genera una vista previa de la imagen
        setPreviewImage(base64String);
      };
      reader.readAsDataURL(file); // Convierte el archivo a Base64
    } else {
      // console.warn("No se seleccionó ningún archivo válido.");
      manejarAlertas("error", "No se selecciono ningun archivo valido");

    }
  };

  const limpiarCampos = () => {
    setTempDatosFormulario({
      dni: "",
      nombre: "",
      apellido: "",
      numero_telefono: "",
      fecha_nacimiento: "",
      password: "",
      email: "",
      direccion: "",
      localidad: "",
      obra_social: "",
      seguro: "",
      esInvitado: "",
    });
    setCampeonatoLicencia(null);
    setLicenciaActual(null);
    setLicenciaFrente("");
    setLicenciaDorso("");
    setPreviewLicenciaFrente("");
    setPreviewLicenciaDorso("");
    setIdUnico(null); // Limpiar el ID del piloto seleccionado
    setPreviewImage("");
    setMostrarBotonLimpiar(false); // Ocultar el botón "+"
    setModalLicenciaVisible(false);
  };
  const onFinish = () => {
    // console.log("Datos del piloto:", tempDatosFormulario);
  };
  // Función para mostrar el formulario y ocultar el botón
  const mostrarFormularioHandler = () => {
    setMostrarFormularioPiloto(true);
    setMostrarFormularioPassword(false); // Asegura que el segundo formulario esté oculto
  };
  //Reseta la contraseña
  const handleResetPassword = async () => {
    if (!idUnico) {

      manejarAlertas("error", "No hay ningún piloto seleccionado para resetear la contraseña.");

      return;
    }
    const validatePasswords = () => {
      if (!passwordNueva || !passwordNuevaRepetir) {

        manejarAlertas("error", "Debes ingresar y repetir la nueva contraseña.");

        return false;
      }

      if (passwordNueva !== passwordNuevaRepetir) {

        manejarAlertas("error", "Las contraseñas no coinciden");

        return false;
      }

      return true;
    };
    // Confirmación antes de resetear
    const result = await MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción reseteará la contraseña del piloto a su DNI.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, resetear",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        // Realizar la solicitud PUT al backend
        const response = await axios.put(
          `${process.env.REACT_APP_DOMINIO}/piloto/${idUnico}/reset-password`,
          { password_nueva: null }, // Indicar que queremos usar el teléfono como contraseña
          HeadersAuth
        );

        if (response.status === 200) {
          
          manejarAlertas("success", "La contraseña del piloto ha sido reseteada con éxito. La nueva contraseña es su DNI.");
        }
      } catch (error) {
        manejarAlertas("error", manejarError(error));

        // manejarError(error);
      }
    }
  };
  //Actualiza la contraseña
  const handleUpdatePassword = async () => {
    // Validar que todos los campos estén completos
    if (!passwordActual || !passwordNueva || !passwordNuevaRepetir) {
     
      manejarAlertas("error", "Debes proporcionar la contraseña actual, la nueva contraseña y repetirla.");

      return;
    }

    // Validar que las contraseñas nuevas coincidan
    if (passwordNueva !== passwordNuevaRepetir) {
      
      manejarAlertas("error", "Las contraseñas nuevas no coinciden.");

      return;
    }

    try {
      // Realizar la solicitud PUT al backend
      const response = await axios.put(
        `${process.env.REACT_APP_DOMINIO}/piloto/${idUnico}/password`,
        { password_actual: passwordActual, password_nueva: passwordNueva },
        HeadersAuth
      );

      if (response.status === 200) {
        
        manejarAlertas("success", "La contraseña del piloto ha sido actualizada con éxito.");
        // Limpiar los campos después de la actualización
        setPasswordActual("");
        setPasswordNueva("");
        setPasswordNuevaRepetir("");

        // Ocultar elementos
        setMostrarFormularioPiloto(false); // Oculta el primer formulario
        setMostrarFormularioPassword(false); // Oculta el segundo formulario
        setMostrarBotonLimpiar(false); // Oculta el botón "+"
        setIdUnico(null); // Resetea el ID único
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };
  const anioActual = new Date().getFullYear();

  const campeonatoActualizado = campeonatosLicencia?.find(
    (camp) => Number(camp.año || camp.anio) === Number(anioActual)
  );

  const idCampeonatoActualTabla = campeonatoActualizado?.id || null;

  const tieneLicenciaCargada = (piloto) => {
    if (!idCampeonatoActualTabla) return false;

    const licenciaCampeonatoActual = piloto.licenciasDeportivas?.find(
      (lic) => Number(lic.id_campeonato) === Number(idCampeonatoActualTabla)
    );

    if (!licenciaCampeonatoActual) return false;

    const tieneImagenes =
      !!licenciaCampeonatoActual.foto_frente &&
      !!licenciaCampeonatoActual.foto_dorso;

    const tienePdf =
      !!licenciaCampeonatoActual.licencia_pdf;

    return tieneImagenes || tienePdf;
  };

  /*Configuración de la tabla */
  const elScroll = { x: 0 };
  const columns = [
    {
      title: "DNI",
      key: "dni",
      align: "right",
      sorter: (a, b) => a.dni - b.dni,
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{a.dni}</div>
      ),
    },
    {
      title: "PILOTO",
      key: "nombre",
      align: "left",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{a.apellido}, {a.nombre}</div>
      ),
    },
    {
      title: "TELÉFONO",
      key: "numero_telefono",
      align: "right",
      sorter: (a, b) => a.numero_telefono.localeCompare(b.numero_telefono),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {a.numero_telefono}
        </div>
      ),
    },
    {
      title: "E-MAIL",
      key: "email",
      align: "left",
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{a.email}</div>
      ),
    },
    {
      title: "LOCALIDAD",
      key: "localidad",
      align: "left",
      sorter: (a, b) => a.localidad.localeCompare(b.localidad),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {a.localidad}
        </div>
      ),
    },
    {
      title: "NACIMIENTO",
      key: "fecha_nacimiento",
      align: "right",
      sorter: (a, b) => a.fecha_nacimiento.localeCompare(b.fecha_nacimiento),
      render: (a) => (
        <span style={{ fontSize: "0.8em" }}>
          {moment(`${a.fecha_nacimiento}`, "YYYY-MM-DD").format("DD/MM/YYYY")}
        </span>
      ),
    },
    {
      title: "LICENCIA",
      key: "licencia",
      align: "center",
      sorter: (a, b) => {
        return tieneLicenciaCargada(a) - tieneLicenciaCargada(b);
      },
      render: (a) => {
        const tieneLicencia = tieneLicenciaCargada(a);

        return (
          <div
            style={{
              fontSize: "12px",
              padding: "2px 4px",
              color: tieneLicencia ? "#16803C" : "#BA1721",
              fontWeight: "600",
            }}
          >
            {tieneLicencia ? "Cargada" : "Sin cargar"}
          </div>
        );
      },
    },
    {
      title: () => (
        <div style={{ textAlign: "center" }}>
          <span></span>
        </div>
      ),
      key: "opciones",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FaRegEdit
            className="iconos-tablas"
            style={{ color: "blue", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(record.id)}
          />
          <FaRegTrashAlt
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => handleEliminarPiloto(record.id)}
          />
        </div>
      ),
    },
  ];

  const getUrlLicenciaPiloto = (licencia, archivo) => {
    if (!licencia || !archivo) return null;

    return `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${licencia.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${licencia.id_campeonato}/piloto_${licencia.id_piloto}/${archivo}`;
  };

  const stylesLicencia = {
    botonImagen: {
      display: "flex",
      width: "100%",
      height: 34,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#223463",
      color: "#fff",
      borderRadius: 5,
      cursor: "pointer",
      fontSize: 15,
    },

    previewBox: {
      marginTop: 12,
      border: "1px solid #d9d9d9",
      borderRadius: 8,
      padding: 8,
      backgroundColor: "#fafafa",
    },

    previewImage: {
      objectFit: "cover",
      borderRadius: 6,
      cursor: "pointer",
    },

    emptyPreview: {
      marginTop: 12,
      height: 180,
      border: "1px dashed #d9d9d9",
      borderRadius: 8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#999",
      backgroundColor: "#fafafa",
    },

    botonCancelar: {
      height: 36,
      padding: "0 18px",
      borderRadius: 5,
      border: "1px solid #d9d9d9",
      backgroundColor: "#fff",
      cursor: "pointer",
    },

    botonGuardar: {
      height: 36,
      padding: "0 18px",
      borderRadius: 5,
      border: "none",
      backgroundColor: "#BA1721",
      color: "#fff",
      cursor: "pointer",
    },

    modalIntro: {
  backgroundColor: "#f8f8f8",
  border: "1px solid #e8e8e8",
  borderRadius: 10,
  padding: 14,
  color: "#555",
  marginBottom: 18,
},

estadoLicencia: {
  padding: 13,
  borderRadius: 10,
  border: "1px solid",
  fontWeight: 600,
},

botonImagen: {
  display: "flex",
  width: "100%",
  height: 38,
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#223463",
  color: "#fff",
  borderRadius: 7,
  cursor: "pointer",
  fontSize: 15,
  fontWeight: 600,
},

botonModoSecundario: {
  display: "flex",
  width: "100%",
  height: 42,
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#223463",
  color: "#fff",
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 15,
  fontWeight: 600,
  marginBottom: 8,
},
botonModoSecundario2: {
  display: "flex",
  width: "50%",
  height: 42,
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#223463",
  color: "#fff",
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 15,
  fontWeight: 600,
  marginBottom: 8,
},

botonModoPdf: {
  display: "flex",
  width: "100%",
  height: 42,
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#BA1721",
  color: "#fff",
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 15,
  fontWeight: 600,
},

previewBox: {
  marginTop: 12,
  border: "1px solid #d9d9d9",
  borderRadius: 10,
  padding: 8,
  backgroundColor: "#fafafa",
},

previewImage: {
  objectFit: "cover",
  borderRadius: 8,
  cursor: "pointer",
},

emptyPreview: {
  marginTop: 12,
  height: 180,
  border: "1px dashed #d9d9d9",
  borderRadius: 10,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#999",
  backgroundColor: "#fafafa",
},

pdfCard: {
  marginTop: 12,
  border: "1px solid #e5e5e5",
  borderRadius: 12,
  padding: 18,
  backgroundColor: "#fafafa",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: 12,
},

botonVerPdf: {
  backgroundColor: "#223463",
  color: "#fff",
  border: "none",
  borderRadius: 6,
},

footerModal: {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginTop: 24,
},

botonCancelar: {
  height: 38,
  padding: "0 20px",
  borderRadius: 7,
  border: "1px solid #d9d9d9",
  backgroundColor: "#fff",
  cursor: "pointer",
  fontWeight: 600,
},

botonGuardar: {
  height: 38,
  padding: "0 20px",
  borderRadius: 7,
  border: "none",
  backgroundColor: "#BA1721",
  color: "#fff",
  cursor: "pointer",
  fontWeight: 600,
},
  };

  const esTelefono = useMediaQuery({ maxWidth: 768 });
  return (
    <>
      {/* Título-Pilotos*/}
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Gestión Pilotos</h1>
      </section>

      {/* Formulario de Pilotos */}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* Contenedor principal para ambos formularios */}
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            padding: "20px",
            margin: "0 auto",
          }}
        >
          {/* Botón Limpiar */}

          {/* Primer Formulario: Gestión de Pilotos */}
          {mostrarFormularioPiloto && (
            <Form onFinish={guardarPiloto}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "1em",
                }}
              >
                {" "}
                <h1 className="titulos-secundarios">Datos del piloto</h1>
                {mostrarBotonLimpiar && (
                  <BotonPrincipal
                    texto="Nuevo piloto"
                    onClick={limpiarCampos}
                  />
                )}
              </div>

              <hr></hr>
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={8}>
                  <Form.Item>
                    <InputCustomNumber
                      idCampo="dni"
                      nombreCampo="DNI"
                      elValue={tempDatosFormulario.dni || ""}
                      elPlaceholder="Ingrese su DNI"
                      min={"100000"}
                      max={"999999999"}
                      step={"1"}
                      required={true}
                      onChange={handleChange}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item>
                    <InputCustom
                      idCampo="nombre"
                      nombreCampo="Nombre"
                      tipo="text"
                      elValue={tempDatosFormulario.nombre || ""}
                      elPlaceholder="Ingrese su nombre"
                      required
                      onChange={handleChange}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item>

                    <InputCustom
                      idCampo="apellido"
                      nombreCampo="Apellido"
                      tipo="text"
                      elValue={tempDatosFormulario.apellido || ""}
                      elPlaceholder="Ingrese su apellido"
                      required
                      onChange={handleChange}
                    />
                  </Form.Item>

                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item>

                    <InputCustom
                      idCampo="numero_telefono"
                      nombreCampo="Teléfono"
                      tipo="number"
                      elValue={tempDatosFormulario.numero_telefono || ""}
                      elPlaceholder="Ingrese su número"
                      required
                      onChange={handleChange}
                    />
                  </Form.Item>

                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item>

                    <InputCustom
                      idCampo="fecha_nacimiento"
                      nombreCampo="Fecha de Nacimiento"
                      tipo="date"
                      elValue={tempDatosFormulario.fecha_nacimiento || ""}
                      required
                      onChange={handleChange}
                    />
                  </Form.Item>

                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item>

                    <InputCustom
                      idCampo="email"
                      nombreCampo="Email"
                      tipo="email"
                      elValue={tempDatosFormulario.email || ""}
                      elPlaceholder="Ingrese su email"
                      required
                      onChange={handleChange}
                      autoComplete="off"
                    />
                  </Form.Item>

                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item>

                    <InputCustom
                      idCampo="localidad"
                      nombreCampo="Localidad"
                      tipo="text"
                      elValue={tempDatosFormulario.localidad || ""}
                      elPlaceholder="Ingrese su localidad"
                      onChange={handleChange}
                    />
                  </Form.Item>

                </Col>
                {/* <Col xs={24} sm={8}>
                  <Form.Item>

                    <InputCustom
                      idCampo="direccion"
                      nombreCampo="Dirección"
                      tipo="text"
                      elValue={tempDatosFormulario.direccion || ""}
                      elPlaceholder="Ingrese su dirección"
                      onChange={handleChange}
                    />
                  </Form.Item>

                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item>

                    <InputCustom
                      idCampo="obra_social"
                      nombreCampo="Obra Social"
                      tipo="text"
                      elValue={tempDatosFormulario.obra_social || ""}
                      elPlaceholder="Ingrese su Obra Social"
                      onChange={handleChange}
                    />
                  </Form.Item>

                </Col> */}
                {/* <Col xs={24} sm={8}>
                  <Form.Item>

                    <InputCustom
                      idCampo="seguro"
                      nombreCampo="Seguro"
                      tipo="text"
                      elValue={tempDatosFormulario.seguro || ""}
                      elPlaceholder="Ingrese su seguro"
                      onChange={handleChange}
                    />
                  </Form.Item>

                </Col> */}
                <Col xs={24} sm={8}>
                  <SelectCustom
                    idCampo="esInvitado"
                    nombreCampo="¿Es Invitado?"
                    arrayOpciones={[
                      { id: "true", nombre: "Sí" },
                      { id: "false", nombre: "No" },
                    ]}
                    textoOpciones="nombre"
                    elValue={
                      tempDatosFormulario.esInvitado === true
                        ? "true"
                        : tempDatosFormulario.esInvitado === false
                        ? "false"
                        : ""
                    }
                    elPlaceholder="Seleccione una opción"
                    onChange={(e) => {
                      const valor = e.target.value === "true";
                      setTempDatosFormulario({
                        ...tempDatosFormulario,
                        esInvitado: valor,
                      });
                    }}
                  />
                </Col>
                <Col 
                  xs={24} sm={8}
                  className="colMostrarForm"
                  style={{ 
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    width: "100%",
                  }}
                >
                  <Form.Item
                    style={{
                      width: "100%",
                    }}
                  >
                    {/* Contenedor principal */}
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        width: "100%",
                      }}
                    >
                      <label
                        htmlFor="image-upload"
                        style={{
                          display: "flex",
                          width: "50%",
                          height: 30,
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#223463",
                          color: "#fff",
                          borderRadius: "5px",
                          cursor: "pointer",
                          fontSize: "16px",
                          marginTop: "1.4em",
                        }}
                      >
                        <span style={{ marginRight: "10px" }}>↑</span>
                        <span
                          style={{
                            height: "30px",
                            width: "0.5px",
                            backgroundColor: "#fff",
                            margin: "0 10px",
                          }}
                        />
                        Subir imagen
                      </label>

                      <input
                        id="image-upload"
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        onChange={handleImageChange}
                        style={{ display: "none", width: "100%" }}
                      />

                      <button
                        type="button"
                        onClick={() => {
                          const idCampActual = campeonatoActual?.id || null;

                          setCampeonatoLicencia(idCampActual);
                          setModalLicenciaVisible(true);

                          if (idUnico && idCampActual) {
                            obtenerLicenciaWeb(idUnico, idCampActual);
                          } else {
                            setLicenciaActual(null);
                            setPreviewLicenciaFrente("");
                            setPreviewLicenciaDorso("");
                            setPreviewLicenciaPdf("");
                          }
                        }}
                        style={{
                          display: "flex",
                          width: "50%",
                          height: 30,
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#BA1721",
                          color: "#fff",
                          borderRadius: "5px",
                          cursor: "pointer",
                          fontSize: "16px",
                          border: "none",
                          marginTop: "1.4em",
                        }}
                      >
                        <span style={{ marginRight: "10px" }}>↑</span>
                        <span
                          style={{
                            height: "30px",
                            width: "0.5px",
                            backgroundColor: "#fff",
                            margin: "0 10px",
                          }}
                        />
                        Licencia
                      </button>
                    </div>
                  </Form.Item>
                </Col>
                
              </Row>
              <Row justify="center">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="boton-principal"
                  style={{ width:"50%" }}
                >
                  Cargar Piloto
                </Button>
              </Row>
            </Form>
          )}

          {/* Segundo Formulario: Actualizar Contraseña */}

          {mostrarFormularioPassword && idUnico && (
            <Form style={{ marginTop: "20px" }}>
              <Row justify="space-between" align="middle">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between", // Distribuye los elementos con espacio entre ellos
                    width: "100%", // Asegura que el contenedor ocupe todo el ancho disponible
                    marginBottom: "1em",
                  }}
                >
                  {/* Título */}
                  <h1 className="titulos-secundarios">
                    Gestión de contraseñas
                  </h1>

                  {/* Botón */}
                  {idUnico && (
                    <Button
                      danger
                      onClick={handleResetPassword}
                      className="boton-azul"
                    >
                      Resetear Contraseña
                    </Button>
                  )}
                </div>
              </Row>
              <hr />
              <Row gutter={[16, 16]}>
                {/* Campo de Contraseña Actual */}
                <Col xs={24} sm={8}>
                  <InputCustom
                    idCampo="password_actual"
                    nombreCampo="Contraseña Actual"
                    tipo="password"
                    elValue={passwordActual}
                    elPlaceholder="Ingrese su contraseña actual"
                    required
                    onChange={(e) => setPasswordActual(e.target.value)}
                  />
                </Col>
                {/* Campo de Contraseña Nueva */}
                <Col xs={24} sm={8}>
                  <InputCustom
                    idCampo="password_nueva"
                    nombreCampo="Contraseña Nueva"
                    tipo="password"
                    elValue={passwordNueva}
                    elPlaceholder="Ingrese su nueva contraseña"
                    required
                    onChange={(e) => setPasswordNueva(e.target.value)}
                  />
                </Col>
                {/* Campo de Repetir Contraseña Nueva */}
                <Col xs={24} sm={8}>
                  <InputCustom
                    idCampo="password_repetir"
                    nombreCampo="Repetir nueva contraseña"
                    tipo="password"
                    elValue={passwordNuevaRepetir}
                    elPlaceholder="Repita su nueva contraseña"
                    required
                    onChange={(e) => setPasswordNuevaRepetir(e.target.value)}
                  />
                </Col>
              </Row>
              {/* Botón para Actualizar Contraseña */}
              <Row justify="start">
                <div style={{ display: "inline-block", marginTop: "1.5em" }} >
                  <BotonPrincipal
                    texto="Actualizar Contraseña"
                    onClick={handleUpdatePassword}
                  />
                </div>
              </Row>
            </Form>
          )}
        </div>
      </section>
      {/* Tabla de resultados */}
      <div
        className="botonDescargar"
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "flex-end",
           padding:"0 16px"
        }}
      >
        <br></br>
        <TablaCompleta
          tituloPDF={"pilotos"}
          elScroll={elScroll}
          columns={columns}
          fetchDatos={fetchDatos.length > 0 ? fetchDatos : []}
          rowKey={"id"}
          gestionTabla={
            <Row style={{ gap: "10px" }}>
              {!mostrarFormularioPiloto && (
                <BotonPrincipal
                  texto={esTelefono ? <PlusOutlined /> : "Agregar"}
                  onClick={mostrarFormularioHandler}
                />
              )}
              {!mostrarFormularioPiloto && (
                <Checkbox
                  translate="no" 
                  className="notranslate"
                  style={{
                    backgroundColor: "#233463",
                    fontSize: 16,
                    color: "#fff",
                    paddingLeft: 8,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 5,
                  }}
                  onClick={onChange}
                >
                  {esTelefono ? <UserSwitchOutlined /> : "Solo pilotos invitados"}
                </Checkbox>
              )}
            </Row>
          }
          tituloBanner={"Pilotos"}
          idAsociacion={sesion.id_asociacion}
        />
      </div>
      {dataNotificacion.length > 0 && (
        <ModalNotificacion
          open={abrirModalNotificacion}
          onCancel={() => setAbrirModalNotificacion(false)}
          datos={dataNotificacion}
          id_asociacion={sesion.id_asociacion}
          HeadersAuth={HeadersAuth}
          setAlerta={setAlerta}
        />
      )}

      <Modal
  open={modalLicenciaVisible}
  onCancel={() => setModalLicenciaVisible(false)}
  footer={null}
  centered
  width={780}
  title={
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <IdcardOutlined style={{ color: "#BA1721", fontSize: 22 }} />
      <span>Licencia médica</span>
    </div>
  }
>
  <div style={stylesLicencia.modalIntro}>
    <p style={{ margin: 0 }}>
      Seleccione el campeonato y cargue la licencia médica en formato imágenes o PDF.
    </p>
    <span>Este paso es opcional.</span>
  </div>

  <Form layout="vertical">
    <Row gutter={[16, 16]}>
      <Col xs={24}>
        <Form.Item label="Campeonato">
          <Select
            placeholder="Seleccione un campeonato"
            value={campeonatoLicencia}
            onChange={(value) => {
              setCampeonatoLicencia(value);

              setModoLicencia("");
              setLicenciaFrente("");
              setLicenciaDorso("");
              setLicenciaPdf("");
              setPreviewLicenciaFrente("");
              setPreviewLicenciaDorso("");
              setPreviewLicenciaPdf("");

              if (idUnico && value) {
                obtenerLicenciaWeb(idUnico, value);
              } else {
                setLicenciaActual(null);
              }
            }}
            allowClear
            style={{ width: "100%" }}
          >
            {campeonatosLicencia.map((camp) => (
              <Select.Option key={camp.id} value={camp.id}>
                {camp.nombre_campeonato} - {camp.año}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      {campeonatoLicencia && (
        <>
          <Col xs={24}>
            <div
              style={{
                ...stylesLicencia.estadoLicencia,
                backgroundColor: licenciaActual ? "#f6ffed" : "#fff7e6",
                color: licenciaActual ? "#237804" : "#ad6800",
                borderColor: licenciaActual ? "#b7eb8f" : "#ffd591",
              }}
            >
              {licenciaActual
                ? "Licencia cargada. Podés reemplazarla por imágenes o por PDF."
                : "Licencia no cargada. Podés cargar frente/dorso o un PDF."}
            </div>
          </Col>

          <Col xs={24}>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <button
                type="button"
                onClick={() => {
                  setModoLicencia("imagenes");
                  limpiarPdfLicencia();
                }}
                style={{
                  flex: 1,
                  minWidth: 180,
                  backgroundColor: modoLicencia === "imagenes" ? "#BA1721" : "#fff",
                  color: modoLicencia === "imagenes" ? "#fff" : "#BA1721",
                  border: "1px solid #BA1721",
                  borderRadius: 8,
                  padding: "10px 14px",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Cargar imágenes
              </button>

              <button
                type="button"
                onClick={() => {
                  setModoLicencia("pdf");
                  limpiarImagenesLicencia();
                }}
                style={{
                  flex: 1,
                  minWidth: 180,
                  backgroundColor: modoLicencia === "pdf" ? "#BA1721" : "#fff",
                  color: modoLicencia === "pdf" ? "#fff" : "#BA1721",
                  border: "1px solid #BA1721",
                  borderRadius: 8,
                  padding: "10px 14px",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Cargar PDF
              </button>
            </div>
          </Col>

          {modoLicencia === "imagenes" && (
            <>
              <Col xs={24} md={12}>
                <Form.Item label="Frente de la licencia">
                  <label
                    htmlFor="licencia-frente"
                    style={stylesLicencia.botonImagen}
                  >
                    Seleccionar frente
                  </label>

                  <input
                    id="licencia-frente"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => handleLicenciaImageChange(e, "frente")}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaFrente ? (
                    <div style={stylesLicencia.previewBox}>
                      <Image
                        src={previewLicenciaFrente}
                        alt="Frente licencia médica"
                        width="100%"
                        height={180}
                        style={stylesLicencia.previewImage}
                      />
                    </div>
                  ) : (
                    <div style={stylesLicencia.emptyPreview}>
                      Sin imagen cargada
                    </div>
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item label="Dorso de la licencia">
                  <label
                    htmlFor="licencia-dorso"
                    style={stylesLicencia.botonImagen}
                  >
                    Seleccionar dorso
                  </label>

                  <input
                    id="licencia-dorso"
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => handleLicenciaImageChange(e, "dorso")}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaDorso ? (
                    <div style={stylesLicencia.previewBox}>
                      <Image
                        src={previewLicenciaDorso}
                        alt="Dorso licencia médica"
                        width="100%"
                        height={180}
                        style={stylesLicencia.previewImage}
                      />
                    </div>
                  ) : (
                    <div style={stylesLicencia.emptyPreview}>
                      Sin imagen cargada
                    </div>
                  )}
                </Form.Item>
              </Col>

              {/* <Col xs={24}>
                <button
                  type="button"
                  onClick={() => {
                    setModoLicencia("pdf");
                    limpiarImagenesLicencia();
                  }}
                  style={stylesLicencia.botonModoPdf}
                >
                  Cargar PDF en lugar de imágenes
                </button>
              </Col> */}
            </>
          )}

          {modoLicencia === "pdf" && (
            <>
              <Col xs={24}>
                <Form.Item label="PDF de la licencia">
                  <label
                    htmlFor="licencia-pdf"
                    style={stylesLicencia.botonModoPdf}
                  >
                    Seleccionar PDF
                  </label>

                  <input
                    id="licencia-pdf"
                    type="file"
                    accept="application/pdf"
                    onChange={handleLicenciaPdfChange}
                    style={{ display: "none" }}
                  />

                  {previewLicenciaPdf ? (
                    <div style={stylesLicencia.pdfCard}>
                      <FilePdfOutlined
                        style={{ fontSize: 48, color: "#BA1721" }}
                      />

                      <div>
                        <h3 style={{ margin: "6px 0 4px" }}>
                          PDF seleccionado
                        </h3>
                        <p style={{ margin: 0, color: "#666" }}>
                          Se guardará solamente este PDF.
                        </p>
                      </div>

                      <Button
                        href={previewLicenciaPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={stylesLicencia.botonVerPdf}
                      >
                        Ver PDF
                      </Button>
                    </div>
                  ) : (
                    <div style={stylesLicencia.emptyPreview}>
                      Sin PDF cargado
                    </div>
                  )}
                </Form.Item>
              </Col>

              {/* <Col xs={24}>
                <button
                  type="button"
                  onClick={() => {
                    setModoLicencia("imagenes");
                    limpiarPdfLicencia();
                  }}
                  style={stylesLicencia.botonImagen}
                >
                  Cargar imágenes en lugar del PDF
                </button>
              </Col> */}
            </>
          )}
        </>
      )}
    </Row>

    <div style={stylesLicencia.footerModal}>
      <button
        type="button"
        onClick={() => setModalLicenciaVisible(false)}
        style={stylesLicencia.botonCancelar}
      >
        Cerrar
      </button>

      <button
        type="button"
        onClick={async () => {
          if (!campeonatoLicencia) {
            manejarAlertas("error", "Seleccione un campeonato.");
            return;
          }

          if (idUnico) {
            await guardarLicenciaWeb();
          }

          setModalLicenciaVisible(false);
        }}
        style={stylesLicencia.botonGuardar}
      >
        {idUnico
          ? licenciaActual
            ? "Actualizar licencia"
            : "Guardar licencia"
          : "Guardar para cargar piloto"}
      </button>
    </div>
  </Form>
</Modal>
    </>
  );
};
